import { render, staticRenderFns } from "./CaseSubmission.vue?vue&type=template&id=61ade606&scoped=true"
import script from "./CaseSubmission.vue?vue&type=script&lang=js"
export * from "./CaseSubmission.vue?vue&type=script&lang=js"
import style0 from "./CaseSubmission.vue?vue&type=style&index=0&id=61ade606&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ade606",
  null
  
)

export default component.exports